export enum CreditFeatureType {
  ProfileView = 1,
  MessageSend,
  WatchPrivateVideo,
  Boost,
}

export interface CreditFeatures {
  name: string;
  credits: number;
  type: CreditFeatureType;
}

export interface Credits {
  amount: number;
  currency: string;
  credit_features: CreditFeatures[];
}
